import { DomeComponent, React } from "@lexriver/dome";
import { UrlGenerator } from "../UrlGenerator";
import css from './Breadcrumbs.m.scss';

interface Attrs{
    items: {text: string, href?: string}[]
}
export class Breadcrumbs extends DomeComponent<Attrs>{
    render(){
        return (
            <ul class={css.breadcrumbs}>
                <li><a href={UrlGenerator.home}>Главная</a></li>
                {this.attrs.items.map(item => {
                    if(item.href){
                        return <li><a href={item.href}>{item.text}</a></li>
                    }
                    return <li>{item.text}</li>
                })}
            </ul>
        )
        
    }
}